<template>
    <section class="0-page-bottom-spacing-medium u-padding-bottom-large">

        <page-header>
            <slot slot="title">Downloads & Media</slot>
            <slot slot="description">
                <button @click="openBox" class="c-button c-button--alpha">
                  {{ $t('global.open_box') }}
                </button>
            </slot>
        </page-header>

        <v-overview-list
          data-table="Downloads"
          data-filter="DownloadsFilters"
          filter-theme="white"
          :filters="Filters"
          :table-columns="Columns"
          :btnCopy="false"
          :page-size="500"
          :row-selectable="true"
          @selectedRows="selectedRows"
          prefix="lop"
          :searchFilter="true">
        </v-overview-list>

        <div v-if="serverInfo" class="o-wrapper o-wrapper--center u-color-error-base u-margin-bottom u-font-weight-bold u-text-align-center">
          {{ serverInfo }}
        </div>

        <div class="o-wrapper o-wrapper--center">
          <button @click="sendDownloads('materials')" :disabled="!selectedItems.length || disabled" class="c-button c-button--alpha">{{ $t('global.download_all') }}</button>
          <button @click="sendDownloads('sheets')" :disabled="!selectedItems.length || disabled" class="c-button c-button--neutral">{{ $t('global.download_productsheet') }}</button>
          <button @click="sendDownloads('images')" :disabled="!selectedItems.length || disabled" class="c-button c-button--neutral">{{ $t('global.download_images') }}</button>
          <button @click="getProductInfoAsCsv()" :disabled="!selectedItems.length || disabled" class="c-button c-button--neutral">{{ $t('global.download_information') }}</button>
        </div>

        <v-modal ref="modal">
          <iframe allowfullscreen="" frameborder="0" height="600" mozallowfullscreen="" msallowfullscreen="" oallowfullscreen="" src="https://app.box.com/embed_widget/s61gfe1vffo6/s/ks0syc8ekh?view=icon&sort=name&direction=ASC&theme=gray" webkitallowfullscreen="" width="100%"></iframe>
        </v-modal>  

    </section>

</template>

<script>
    import VModal from '@/components/modal/Modal'
    import PageHeader from '@/components/common/PageHeader'
    import VOverviewList from '@/components/OverviewList'
    import FilesHelper from '@/helpers/files'

    export default {
        components: {
            VModal,
            PageHeader,
            VOverviewList
        },
        data() {
            return {
              disabled: false,
              serverInfo: null,
              selectedItems: []
            }
        },
        computed: {
          Filters() {
            return [
                { name: this.$t('preorder_overview.filters.brands'), value: 'Brands', single: 'Brands', width:120 },
                { name: this.$t('preorder_overview.filters.collections'), value: 'Collections', single: 'Collections', width: 130 },
                { name: this.$t('preorder_overview.filters.colors'), value: 'Colors', single: 'Colors', width:120 },
                { name: this.$t('preorder_overview.filters.type'), value: 'Type', single: 'Type' },
                { name: this.$t('global.bought'), value: 'AlreadyPurchased', single: 'alreadyPurchased', allowMultiple: false, width:200 },
              ]
          },
          Columns() {
            return [
                { value: 'ThumbnailUrl', name: this.$t('global.image'), type: "Image", sortable: false },
                { value: 'BrandName', name: this.$t('global.brand'), sortable: false },
                { value: 'Name', name: this.$t('global.product_name'), sortable: false },
                { value: 'ErpId', name: this.$t('global.product_code'), sortable: false },
                { value: 'ColorHexCode', name: this.$t('global.color'), type: 'Color', sortable: false },
                { value: 'ColorCode', name: this.$t('global.color_code'), sortable: false },
                { value: 'ColorName', name: this.$t('global.color_name'), sortable: false },
                { value: 'Collection', name: this.$t('global.collection'), sortable: false },
                { value: 'Purchased', name: this.$t('global.bought'), type: 'Boolean', sortable: false }
            ]
          }
        },
        methods: {
          openBox() {
            this.$refs.modal.openDialog();
          },
          selectedRows(values) {
            this.selectedItems = values;
          },
          sendDownloads(type) {
            this.disabled = true;
            this.serverInfo = null,

            this.$store.dispatch('sendDownloads', {
              type: type,
              body: this.selectedItems
            }).then((response) => {
              window.location = response.Url;              
              this.disabled = false;
            }).catch((response) => {
              this.serverInfo = response;
              this.disabled = false;
            });

          },
          getProductInfoAsCsv() {
            this.disabled = true;
            this.serverInfo = null,

            this.$store.dispatch('getProductInfoAsCsv', this.selectedItems).then((response) => {
              response = "\uFEFF" + response;
              FilesHelper.saveFile("Product-Info.csv", "text/csv;charset=utf-8", response);
              this.disabled = false;
            }).catch((response) => {
              this.serverInfo = response;
              this.disabled = false;
            });
          }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/customer/downloads/Overview.vue